import React, { useCallback, useContext, useState, useMemo } from 'react';
import styled from 'astroturf/react'
import { format, formatDistanceToNowStrict } from 'date-fns';
import { partition } from 'lodash';

import { Comment, FollowableUser, NewsType } from 'js/social/shared/types';
import { Body } from 'js/design_system/Body';
import { TextButton } from 'js/design_system/TextButton';
import { SocialEditor } from 'js/social/shared/SocialEditor/SocialEditor';
import { CreateReply } from '../CreateSocialItem/CreateReply';
import { FeedContext } from 'js/social/contexts/feed';
import useCommentInteractionsBase from 'js/social/Comment/useCommentInteractions';
import useShowToggle from 'js/social/shared/useShowToggle';
import {
  ImpressionProps,
  ImpressionWatcher,
  ImpressionEntity,
} from 'js/utils/impressions';
import { useCurrentUserAsAuthor } from 'js/social/shared/CreateSocialItem';
import { SocialActionsMenu } from 'js/social/shared/Menu';
import { Icon } from 'js/design_system/Icon';
import { useConfirmationModal } from 'js/social/shared/ConfirmationModal';
import { AuthorHeader, AuthorAvatar } from './AuthorHeader';
import _CommentsWrapper from "Comments-CommentsWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentsWrapper";
import _CommentItem from "Comments-CommentItem.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentItem";
import _CommentThread from "Comments-CommentThread.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentThread";
import _ReplyThread from "Comments-ReplyThread.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ReplyThread";
import _ThreadCorner from "Comments-ThreadCorner.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ThreadCorner";
import _ThreadCornerLine from "Comments-ThreadCornerLine.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ThreadCornerLine";
import _ThreadCornersWrapper from "Comments-ThreadCornersWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ThreadCornersWrapper";
import _StretchedAuthorHeader from "Comments-StretchedAuthorHeader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=StretchedAuthorHeader";
import _CommentContent from "Comments-CommentContent.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentContent";
import _ReplyContext from "Comments-ReplyContext.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ReplyContext";
import _CommentHeader from "Comments-CommentHeader.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentHeader";
import _CommentActions from "Comments-CommentActions.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentActions";
import _Dot from "Comments-Dot.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=Dot";
import _ReactionCount from "Comments-ReactionCount.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ReactionCount";
import _ActionButton from "Comments-ActionButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ActionButton";
import _AvatarThread from "Comments-AvatarThread.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=AvatarThread";
import _ThreadLine from "Comments-ThreadLine.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ThreadLine";
import _ReplyWrapper from "Comments-ReplyWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=ReplyWrapper";
import _CommentMetadata from "Comments-CommentMetadata.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=CommentMetadata";
import _Timestamp from "Comments-Timestamp.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=Timestamp";
import _MoreButton from "Comments-MoreButton.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=MoreButton";
import _MenuButtonClassName from "Comments-MenuButtonClassName.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=MenuButtonClassName";
import _SocialEditorSmall from "Comments-SocialEditorSmall.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=SocialEditorSmall";
import _SocialEditorMedium from "Comments-SocialEditorMedium.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/CoreX/News/Comments.tsx?styleId=SocialEditorMedium";


const CommentsWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "CommentsWrapper",
  styles: _CommentsWrapper
});

const CommentItem = /*#__PURE__*/styled("div", null, {
  displayName: "CommentItem",
  styles: _CommentItem
});

const CommentThread = /*#__PURE__*/styled("div", null, {
  displayName: "CommentThread",
  styles: _CommentThread
});

const ReplyThread = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyThread",
  styles: _ReplyThread
});

const ThreadCorner = /*#__PURE__*/styled("div", null, {
  displayName: "ThreadCorner",
  styles: _ThreadCorner
});

const ThreadCornerLine = /*#__PURE__*/styled("div", null, {
  displayName: "ThreadCornerLine",
  styles: _ThreadCornerLine
});

const ThreadCornersWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ThreadCornersWrapper",
  styles: _ThreadCornersWrapper
});

const StretchedAuthorHeader = /*#__PURE__*/styled("div", null, {
  displayName: "StretchedAuthorHeader",
  styles: _StretchedAuthorHeader
});

const CommentContent = /*#__PURE__*/styled("div", null, {
  displayName: "CommentContent",
  styles: _CommentContent
});

const ReplyContext = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyContext",
  styles: _ReplyContext
});

const CommentHeader = /*#__PURE__*/styled("div", null, {
  displayName: "CommentHeader",
  styles: _CommentHeader
});

const CommentActions = /*#__PURE__*/styled("div", null, {
  displayName: "CommentActions",
  styles: _CommentActions
});

const Dot = /*#__PURE__*/styled("div", null, {
  displayName: "Dot",
  styles: _Dot
});

const ReactionCount = /*#__PURE__*/styled(Body, null, {
  displayName: "ReactionCount",
  styles: _ReactionCount
});

const ActionButton = /*#__PURE__*/styled(TextButton, null, {
  displayName: "ActionButton",
  styles: _ActionButton
});

const AvatarThread = /*#__PURE__*/styled("div", null, {
  displayName: "AvatarThread",
  styles: _AvatarThread
});

const ThreadLine = /*#__PURE__*/styled("div", null, {
  displayName: "ThreadLine",
  styles: _ThreadLine
});

const ReplyWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ReplyWrapper",
  styles: _ReplyWrapper
});

const CommentMetadata = /*#__PURE__*/styled("div", null, {
  displayName: "CommentMetadata",
  styles: _CommentMetadata
});

const Timestamp = /*#__PURE__*/styled(Body, null, {
  displayName: "Timestamp",
  styles: _Timestamp
});

const MoreButton = /*#__PURE__*/styled("div", null, {
  displayName: "MoreButton",
  styles: _MoreButton
});

const MenuButtonClassName = _MenuButtonClassName.cls2;

const SocialEditorSmall = _SocialEditorSmall.cls2;

const SocialEditorMedium = _SocialEditorMedium.cls2;

const ThreadCorners = ({
  isLastComment,
  isForMoreButton,
}: {
  isLastComment: boolean;
  isForMoreButton?: boolean;
}) => {
  return (
    <ThreadCornersWrapper>
      <ThreadCorner short={isForMoreButton} />
      {!isLastComment && <ThreadCornerLine />}
    </ThreadCornersWrapper>
  );
};

const useCommentInteractions = ({
  newsType,
  newsId,
  comment,
  parentComment,
  author,
}: {
  newsId: number | string;
  newsType: NewsType;
  comment: Comment;
  parentComment: Comment | null;
  author: FollowableUser;
}) => {
  const {
    userActions: { setUserFollowing },
    newsActions: {
      removeUserContent,
      addFeedComment,
      removeFeedComment,
      updateFeedComment,
      likeFeedComment,
      unlikeFeedComment,
    },
  } = useContext(FeedContext);

  // TODO(emily): Allow deeper nesting of comments.
  // Currently we don't allow adding three-level-deep comments. There isn't
  // anything in the models that prevents this, but it is implicitly assumed in
  // a bunch of places within the action callbacks from useNews(). When fixing
  // this, also change <CreateReply> to handle the depth appropriately.
  return useCommentInteractionsBase({
    newsType,
    commentId: comment.id,
    commentableId: newsId,
    parentCommentId: parentComment?.id ?? null,
    userId: author.id,
    tags: comment.tags,
    setUserFollowing,
    removeUserContent,
    addFeedComment,
    removeFeedComment,
    updateFeedComment,
    likeFeedComment,
    unlikeFeedComment,
  });
};

type SharedProps = {
  newsType: NewsType;
  newsId: number | string;
  getAuthor: (comment: Comment) => FollowableUser;
  impressionPropsGen: (
    entityType?: ImpressionEntity,
    entityId?: number | string,
  ) => (element?: string) => (clickTarget?: string) => ImpressionProps;
};

const SingleComment = ({
  newsType,
  newsId,
  depth,
  comment,
  parentComment,
  commentExpansionStatus,
  getAuthor,
  expandComments,
  impressionPropsGen,
  commentIdToIndex,
}: SharedProps & {
  depth: number;
  comment: Comment;
  parentComment: Comment | null;
  commentExpansionStatus: Map<Comment['id'], boolean>;
  expandComments: (commentIds: Comment['id'][]) => void;
  commentIdToIndex: Map<Comment['id'], number>;
}) => {
  const {
    isShown: showReplyModal,
    hide: closeReplyModal,
    show: openReplyModal,
  } = useShowToggle(false);

  const author = getAuthor(comment);
  const currentUserAuthor = useCurrentUserAsAuthor();

  const hasReplies = comment.replies.count > 0;
  const numReplies = comment.replies.count;
  const [visibleReplies, hiddenReplies] = partition(
    comment.replies.data,
    (reply) => getCommentExpansionStatus(commentExpansionStatus, reply),
  );

  const {
    actions: { likeComment, unlikeComment, createReply, deleteComment },
    permissions,
  } = useCommentInteractions({
    newsType,
    newsId,
    comment,
    parentComment,
    author,
  });

  const deleteCommentModal = useConfirmationModal();

  const triggerDeleteCommentModal = useCallback(() => {
    deleteCommentModal.openModal(
      'Delete Comment',
      'Are you sure you want to delete this comment?',
      'Delete',
      async () => {
        deleteCommentModal.setDisableAction(true);
        try {
          await deleteComment();
          deleteCommentModal.closeModal();
        } finally {
          deleteCommentModal.setDisableAction(false);
        }
      },
    );
  }, [deleteCommentModal, deleteComment]);

  const expandHiddenReplies = useCallback(() => {
    expandComments(hiddenReplies.map((reply) => reply.id));
  }, [expandComments, hiddenReplies]);

  const onToggleLike = useCallback(() => {
    if (comment.reactions.like.reacted) {
      unlikeComment();
    } else {
      likeComment();
    }
  }, [likeComment, unlikeComment, comment]);

  const commentImpressionPropsGen = impressionPropsGen(
    ImpressionEntity.Comment,
    comment.id,
  )(`comment-${commentIdToIndex.get(comment.id)}`);

  return (
    <>
      <CommentThread>
        <ImpressionWatcher {...commentImpressionPropsGen()}>
          <CommentItem>
            <AvatarThread>
              <AuthorAvatar kind="user" user={author} size="xs" />
              {hasReplies && <ThreadLine />}
            </AvatarThread>
            <CommentContent>
              <CommentHeader>
                <StretchedAuthorHeader>
                  <AuthorHeader
                    kind="user"
                    user={author}
                    size="xs"
                    showAvatar={false}
                    impressionPropsGen={() => () => commentImpressionPropsGen}
                    showTimestamp={false}
                  />
                </StretchedAuthorHeader>
                <CommentMetadata>
                  <time
                    dateTime={comment.createdAt}
                    title={format(new Date(comment.createdAt), 'PPpp')}
                  >
                    <Timestamp size="xs">
                      {formatDistanceToNowStrict(new Date(comment.createdAt))}
                    </Timestamp>
                  </time>
                  {permissions.canDelete && (
                    <SocialActionsMenu
                      placement="bottom-end"
                      menuItems={[
                        {
                          showItem: permissions.canDelete,
                          itemIcon: <Icon name="delete" />,
                          itemText: 'Delete',
                          onClick: triggerDeleteCommentModal,
                          impressionProps:
                            commentImpressionPropsGen('delete-comment'),
                        },
                      ]}
                      buttonClassName={MenuButtonClassName}
                    />
                  )}
                </CommentMetadata>
              </CommentHeader>
              <SocialEditor
                readOnly
                content={comment.content}
                tags={comment.tags}
                allowedHashtags={comment.hashtags.map(
                  (hashtag) => hashtag.hashtag,
                )}
                lines={5}
                containerClassName={SocialEditorSmall}
              />
              <CommentActions>
                <ImpressionWatcher
                  {...commentImpressionPropsGen('comment-like')}
                >
                  <ActionButton size="sm" inline onClick={onToggleLike}>
                    {comment.reactions.like.reacted ? 'Liked' : 'Like'}
                  </ActionButton>
                </ImpressionWatcher>
                {comment.reactions.like.count > 0 && (
                  <ReactionCount size="sm">
                    {comment.reactions.like.count}
                  </ReactionCount>
                )}
                <Dot />
                <ImpressionWatcher
                  {...commentImpressionPropsGen('comment-reply')}
                >
                  <ActionButton size="sm" inline onClick={openReplyModal}>
                    Reply
                  </ActionButton>
                </ImpressionWatcher>
                {/* TODO(emily): should clicking this collapse and expand comments like
                 * it does in the noncorex comments? */}
                {hasReplies && (
                  <ReactionCount size="sm">{numReplies}</ReactionCount>
                )}
              </CommentActions>
            </CommentContent>
          </CommentItem>
        </ImpressionWatcher>
        {hasReplies && (
          <ReplyThread>
            {visibleReplies.map((reply, index) => (
              <ReplyWrapper key={reply.id}>
                <ThreadCorners
                  isLastComment={
                    hiddenReplies.length === 0 &&
                    index === visibleReplies.length - 1
                  }
                />
                <SingleComment
                  newsType={newsType}
                  newsId={newsId}
                  depth={depth + 1}
                  comment={reply}
                  parentComment={comment}
                  commentExpansionStatus={commentExpansionStatus}
                  getAuthor={getAuthor}
                  expandComments={expandComments}
                  impressionPropsGen={impressionPropsGen}
                  commentIdToIndex={commentIdToIndex}
                />
              </ReplyWrapper>
            ))}
            {hiddenReplies.length > 0 && (
              <ReplyWrapper>
                <ThreadCorners isLastComment={true} isForMoreButton />
                <MoreButton>
                  <ImpressionWatcher {...commentImpressionPropsGen('see-more')}>
                    <ActionButton
                      size="sm"
                      inline
                      onClick={expandHiddenReplies}
                    >
                      View more replies ({hiddenReplies.length})
                    </ActionButton>
                  </ImpressionWatcher>
                </MoreButton>
              </ReplyWrapper>
            )}
          </ReplyThread>
        )}
      </CommentThread>
      {showReplyModal && (
        <CreateReply
          commentId={comment.id}
          author={currentUserAuthor}
          depth={depth + 1}
          parentComment={comment}
          replyTo={{
            node: (
              <ReplyContext>
                <CommentHeader>
                  <AuthorHeader
                    kind="user"
                    user={author}
                    size="md"
                    showAvatar={false}
                    impressionPropsGen={() => () =>
                      impressionPropsGen(
                        ImpressionEntity.Comment,
                        comment.id,
                      )('comment-modal')}
                    showTimestamp={false}
                  />
                </CommentHeader>
                <SocialEditor
                  readOnly
                  content={comment.content}
                  tags={comment.tags}
                  allowedHashtags={comment.hashtags.map(
                    (hashtag) => hashtag.hashtag,
                  )}
                  lines={5}
                  containerClassName={SocialEditorMedium}
                />
              </ReplyContext>
            ),
            profileImg: <AuthorAvatar kind="user" user={author} size="md" />,
          }}
          onClose={closeReplyModal}
          onSubmit={createReply}
          impressionPropsGen={impressionPropsGen(
            ImpressionEntity.Comment,
            comment.id,
          )}
        />
      )}
      {deleteCommentModal.showModal && deleteCommentModal.modal}
    </>
  );
};

function getCommentExpansionStatus(
  commentExpansionStatus: Map<Comment['id'], boolean>,
  comment: Comment,
): boolean {
  return commentExpansionStatus.get(comment.id) ?? true;
}

function getInitialHiddenCommentIds(comments: Comment[]): Comment['id'][] {
  return comments
    .filter((comment) => !comment.expandByDefault)
    .map((comment) => comment.id)
    .concat(
      comments.flatMap((comment) =>
        getInitialHiddenCommentIds(comment.replies.data),
      ),
    );
}

// A hook to manage the expanded and collapsed state. Derives its initial state
// from the `expandByDefault` flags in the initially provided comments.
const useCommentExpansion = (initialComments: Comment[]) => {
  const initialHiddenComments = getInitialHiddenCommentIds(initialComments);

  const [commentExpansionStatus, setCommentExpansionStatus] = useState(
    new Map(initialHiddenComments.map((id) => [id, false])),
  );

  const expandComments = useCallback(
    (commentIds: Comment['id'][]) => {
      const newExpandedComments = new Map(commentExpansionStatus);
      commentIds.forEach((id) => {
        newExpandedComments.set(id, true);
      });
      setCommentExpansionStatus(newExpandedComments);
    },
    [commentExpansionStatus, setCommentExpansionStatus],
  );

  return {
    commentExpansionStatus,
    expandComments,
  };
};

function traverseComments(
  comments: Comment[],
  callback: (comment: Comment) => void,
) {
  comments.forEach((comment) => {
    callback(comment);
    traverseComments(comment.replies.data, callback);
  });
}

function getCommentIdToIndex(comments: Comment[]): Map<Comment['id'], number> {
  const map = new Map<Comment['id'], number>();

  let index = 0;
  traverseComments(comments, (comment) => {
    map.set(comment.id, index);
    index++;
  });

  return map;
}

export const Comments = ({
  newsType,
  newsId,
  comments,
  getAuthor,
  impressionPropsGen,
  className,
}: SharedProps & {
  comments: Comment[];
  className?: string;
}) => {
  const { commentExpansionStatus, expandComments } =
    useCommentExpansion(comments);

  const [visibleComments, hiddenComments] = partition(comments, (comment) =>
    getCommentExpansionStatus(commentExpansionStatus, comment),
  );

  const handleExpandComments = useCallback(() => {
    expandComments(hiddenComments.map((comment) => comment.id));
  }, [expandComments, hiddenComments]);

  // This map lets us keep track of the overall location of a given comment in
  // the comment tree, which is used for impression tracking.
  // NOTE: if a reply is added which inserts a comment in the middle of the
  // comment tree, these indices will shift and cause new impressions for the
  // same index. We're accepting this tradeoff to know the comment index.
  const commentIdToIndex = useMemo(
    () => getCommentIdToIndex(comments),
    [comments],
  );

  if (comments.length === 0) {
    return null;
  }

  return (
    <CommentsWrapper className={className}>
      {visibleComments.map((comment) => (
        <SingleComment
          key={comment.id}
          newsType={newsType}
          newsId={newsId}
          depth={0}
          comment={comment}
          parentComment={null}
          commentExpansionStatus={commentExpansionStatus}
          getAuthor={getAuthor}
          expandComments={expandComments}
          impressionPropsGen={impressionPropsGen}
          commentIdToIndex={commentIdToIndex}
        />
      ))}
      {hiddenComments.length > 0 && (
        <MoreButton>
          <ImpressionWatcher {...impressionPropsGen()('comment')('see-more')}>
            <ActionButton size="sm" inline onClick={handleExpandComments}>
              View more comments ({hiddenComments.length})
            </ActionButton>
          </ImpressionWatcher>
        </MoreButton>
      )}
    </CommentsWrapper>
  );
};
